import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { ShowcaseLoyaltyTransactionDto } from './ShowcaseLoyaltyTransactionDto'
/**
* Class PageOfShowcaseLoyaltyTransactionDto
*  Результат постраничного запроса
*/
export class PageOfShowcaseLoyaltyTransactionDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [ShowcaseLoyaltyTransactionDto, () => undefined]
  })
  items?: Array<ShowcaseLoyaltyTransactionDto>
}
